import { render } from "./PrivacyPolicy.vue?vue&type=template&id=515904a0&scoped=true&ts=true&lang=pug"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts&setup=true"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=515904a0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515904a0"]])

export default __exports__